import { render, staticRenderFns } from "./FirmwareVersionLabel.vue?vue&type=template&id=45a62c90"
import script from "./FirmwareVersionLabel.vue?vue&type=script&lang=js"
export * from "./FirmwareVersionLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports